<template>
  <div id="careers">
		<base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
		>
		</base-banner>

		<base-goto :breadcrumbs="breadcrumbs"></base-goto>

		<div id="content">
			<div id="work" class="sec">
				<v-container>
					<div class="text-center">

						<iframe
							:width="iframeWidth"
							:height="iframeHeight"
							src="https://www.youtube.com/embed/x44Vc8BtENk"
							frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen
						></iframe>

						<!-- <div
							class="display-2 font-weight-bold primary--text mb-5"
							data-aos="fade-up"
						>
							What working at Medgate means
						</div>

						<p class="mb-10 pb-5" data-aos="fade-up">We are innovative company that focuses on digital health. As a leading provider of<br>telemedicine, we make sure that we always get doctor to where our patients need him.<br>More than 330 motivated staff members our goal of improving healthcare</p>

						<router-link to="/about">
							<base-button
								name="More about Medgate"
								x-large
								color="#0e6ccd"
								icon="mdi-chevron-right"
								data-aos="fade-up"
							></base-button>
						</router-link> -->
					</div>
				</v-container>
			</div>

			<div id="advantages" class="sec">
				<v-container>
					<v-row justify="center">
						<div>
							<div
								:class="[ $vuetify.breakpoint.xs ? 'text-center px-5' : '' , 'font-weight-bold primary--text mb-10', MIXIN_SETUP_UI.header]"
								data-aos="fade-up"
							>
								Advantages of working at Medgate
							</div>

							<div :class="[ $vuetify.breakpoint.xs ? 'pl-5' : 'pl-10' ]">
								<div
									class="mb-4 primary--text text-wrap"
									v-for="(val, key) in advantages"
									:key="key"
									data-aos="fade-up"
									:class="MIXIN_SETUP_UI.title"
								>
									<v-icon class="mr-3" color="#40ecb8">mdi-circle</v-icon>
									{{ val }}
								</div>
							</div>
						</div>
					</v-row>
				</v-container>
			</div>

			<base-divider></base-divider>

			<div id="jobs" class="sec">
				<v-container>
					<v-row justify="center">
						<div class="display-2 head" data-aos="fade-up">Jobs</div>
					</v-row>

					<v-row class="px-4">
						<table data-aos="fade-up">
							<thead>
								<tr>
									<th
										v-for="(head, key) in tableHeads"
										:key="key"
										@click="sortBy(head.description)"
									>
										{{ head.label }}
										<v-icon
											v-if="currentSort === head.description"
											color="#0e6ccd"
										>
											{{ currentSortOrder === 'asc' ? 'mdi-menu-up' : 'mdi-menu-down' }}
										</v-icon>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(job, key) in jobs" :key="key" class="job-row" @click="openJobDialog(job)">
									<td>{{ job.title }}</td>
									<td>{{ job.division }}</td>
									<td>{{ job.location }}</td>
								</tr>
							</tbody>
						</table>
					</v-row>

					<v-row class="mt-15" :class="MIXIN_SETUP_UI.defaultSidePadding">
						<base-title
							title="Employees tell: Why did you join Medgate?"
							size="1"
						></base-title>
					</v-row>
					<v-row justify="center" :class="MIXIN_SETUP_UI.defaultSidePadding">
						<v-col
							cols="12" sm="6" md="6" lg="6" xl="6"
							v-for="(tes, key) in testimonials"
							:key="key"
							class="d-flex"
						>
							<testimonial-card
								:title="tes.title"
								:description="tes.caption"
								:ratings="tes.ratings"
								:name="tes.name"
							></testimonial-card>
						</v-col>
					</v-row>
				</v-container>
			</div>

			<div class="sec">
				<base-title
					title="Apply Now!"
					size="1"
				></base-title>
				<v-row justify="center">
						<!-- <v-col> -->
							<apply-now-form></apply-now-form>
						<!-- </v-col> -->
					</v-row>
			</div>
		</div>

		<job-dialog v-model="jobDialog" :job="currentJob"></job-dialog>
  </div>
</template>

<script>
import JobDialog from "@/components/jobs/JobDialog.vue";
import ApplyNowForm from "@/components/jobs/ApplyNowForm.vue";
import TestimonialCard from "@/components/home/TestimonialCard.vue";

import Repository from "@/api/repositories";
const JobsApi = Repository.get("jobs");
const JobBannersApi = Repository.get("jobBanners");
const JobTestimonialsApi = Repository.get("jobTestimonials");

export default {
  name: "Jobs",
  components: {
		JobDialog,
		TestimonialCard,
		ApplyNowForm
  },
  data() {
    return {
			currentJob: [],
			jobDialog: false,
			banner: [],
			advantages: [
				"Innovative company",
				"Varied responsibilities",
				"Flexible job options and part-time work",
				"Career options"
			],
			jobs: [
				{
					title: "sdfs",
					division: "sdfsdf",
					location: "sdfsdf"
				}
			],
			breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
        {
					name: "Jobs",
					link: "/jobs",
					active: true
				},
			],
			currentSort: 'title',
			currentSortOrder: 'asc',
			tableHeads: [
				{
					label: "Job Title",
					description: "title"
				},
				{
					label: "Division",
					description: "division"
				},
				{
					label: "Location",
					description: "location"
				}
			],
			testimonials: []
		}
	},
  async mounted() {
		this.getJobs();
		await this.getJobBanner();
		this.setHeaderColor();
		this.getJobTestimonials();
	},
	computed: {
		iframeWidth() {
			var width = '0';

			if (this.$vuetify.breakpoint.xs)
				width = '300';
			else if (this.$vuetify.breakpoint.sm)
				width = '703';
			else
				width = '853';
			
			return width;
		},
		iframeHeight() {
			var width = '0';

			if (this.$vuetify.breakpoint.xs)
				width = '180';
			else if (this.$vuetify.breakpoint.sm)
				width = '420';
			else
				width = '480';
			
			return width;
		}
	},
  methods: {
		setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
		async getJobBanner() {
      try {
        const { data } = await JobBannersApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          let buttons = apiData.buttons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }

        console.log('[business-banner]', data, this.banner);
      }
      catch(error) {
        console.log(error);
      }
    },
    async getJobs() {
      try {
        const { data } = await JobsApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
						return a.title.localeCompare(b.title);
					});
          
          let jobs = data.data.map(job => {
            return {
              title: job.title,
              division: job.division,
							location: job.location,
							description: job.description,
							backgroundImage: job.background_image.main
            }
          });

          this.jobs = jobs;
        }

        console.log('[jobs]', data, this.jobs);
      }
      catch(error) {
        console.log(error);
      }
		},
		sortBy(column) {
			var sortedJobs = [];

			if (this.currentSortOrder === 'asc') {
				// sort from a-z
				sortedJobs = this.jobs.sort(function(a, b) {
					return a[column].localeCompare(b[column]);
				});
			}
			if (this.currentSortOrder === 'desc') {
				// sort from z-a
				sortedJobs = this.jobs.slice().reverse();
			}
			
			this.jobs = sortedJobs;

			if (column === this.currentSort) {
				// change sort order
				this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
			}

			// change sort column
			this.currentSort = column;
		},
		openJobDialog(job) {
			this.jobDialog = true
			this.currentJob = job;
			console.log(this.currentJob);
		},
		async getJobTestimonials() {
			try {
				const { data } = await JobTestimonialsApi.get();
				
				if (data) {
					data.data.sort(function(a, b) {
						return a.precedence - b.precedence;
					});

					let testimonials = data.data.map(tes => {
						return {
							name: tes.name,
							title: tes.title,
							ratings: parseInt(tes.ratings),
							caption: tes.caption
						}
					});

					this.testimonials = testimonials;
				}

				console.log('[job-testimonials]', data, this.testimonials);
			}
			catch(error) {
				console.log(error);
			}
		}
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

// #header {
//   height: 700px;
// 	background: url("~@/assets/images/banners/careers.jpg") no-repeat;
// 	background-size: cover;
// 	color: $blue;
// }

#work {
}

#advantages {
	background: white;
}

#jobs {
	background: white;
	color: $blue;

	table {
		width: 100%;
		border-spacing: 0;
		border-collapse: collapse;
		padding: 10px;

		th {
			border-bottom: 4px solid #1d87fd;
			text-align: left;
			cursor: pointer;
		}

		td {
			border-bottom: 2px dashed #1d87fd;
			width: (100% / 3);
		}

		th, td {
			padding: 1%;
		}
	}

	.job-row:hover {
		border: 3px solid $accent-blue;
		cursor: pointer;

		td {
			color: $dark-blue;
			font-weight: bolder;
			z-index: 9999;
		}
	}
}
</style>